import { createModel, RematchDispatch } from '@rematch/core';
import { produce } from 'immer';

import { fetchTermOfContract } from '../../services/termOfContract';
import { TermOfContractType } from '../../types/termOfContract';
import { RootModel } from '../models';
import baseEntity from './base.entity';

export const storeName = 'termOfContractEntity';

export const termOfContract = createModel<RootModel>()({
  name: storeName,
  state: { codes: {} },
  reducers: {
    ...baseEntity,
    saveCodes: produce((state, entities) => {
      (entities || []).forEach((entity: TermOfContractType) => {
        state.codes[entity.code] = entity;
      });
    }),
  },
  effects: (dispatch: RematchDispatch<typeof termOfContract>) => ({
    async fetchAgents(payload) {
      const resp = await fetchTermOfContract(payload);
      if (!resp) return null;
      const { data } = resp;
      this.saveCodes(data.content);
      return resp;
    },
  }),
});

export default termOfContract;
